import {
  Container,
  Image,
  Box,
  Flex,
  Avatar,
  HStack,
  Link,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
  Text,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { HashLink } from "react-router-hash-link";

import logo from "../../assets/images/log.png";

const Links = [
  { title: "Overview", link: "/#overview" },
  { title: "Utility", link: "/#utility" },
  { title: "Roadmap", link: "/#roadmap" },
  { title: "Team", link: "/#team" },
  { title: "FAQ", link: "/#faq" },
  { title: "Socials", link: "/#socials" },
];

const NavLink = ({ link }) => (
  <HashLink smooth to={link.link}>
    <Text
      px={2}
      py={1}
      rounded={"md"}
      color="#FFFFFF"
      fontWeight="700"
      _hover={{
        textDecoration: "none",
        // bg: useColorModeValue("gray.200", "gray.700"),
      }}
      href={link.link}
    >
      {link.title}
    </Text>
  </HashLink>
);

export default function Simple() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      bg={useColorModeValue("brand.100", "brand.100")}
      color="brand.200"
      px={4}
    >
      {/* <Container maxW="container.xl"> */}
      <Flex h={20} alignItems={"center"} justifyContent={"space-between"}>
        <IconButton
          size={"md"}
          bg="none"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label={"Open Menu"}
          display={{ lg: "none" }}
          onClick={isOpen ? onClose : onOpen}
        />
        <Image
          src={logo}
          bjectFit={{ base: "" }}
          w={{ base: "50px", md: "80px" }}
        />
        <HStack
          spacing={8}
          alignItems={"center"}
          display={{ base: "none", lg: "block" }}
        >
          <HStack as={"nav"} spacing={4} display={{ base: "none", lg: "flex" }}>
            {Links.map((link) => (
              <NavLink key={link.title} link={link} />
            ))}
          </HStack>
        </HStack>
        <Button
          variant="primary"
          display={{ base: "none", lg: "block" }}
          size="lg"
        >
          <a href="https://opensea.io/MarbleverseNFT">View on Opensea</a>
        </Button>
      </Flex>

      {isOpen ? (
        <Box pb={4} display={{ lg: "none" }}>
          <Stack as={"nav"} spacing={4}>
            {Links.map((link) => (
              <NavLink key={link} link={link} />
            ))}
          </Stack>
        </Box>
      ) : null}
      {/* </Container> */}
    </Box>
  );
}
